import {getField, updateField} from 'vuex-map-fields'
import {ViolationEvent, ViolationRule, VIOLATION_ROLE, Group, ORDER_TOKEN} from '../../object'
import {F} from '../../ladmin/utils'

class RuleNode extends ViolationRule {
  constructor (o = {}) {
    super(o)
    o = o instanceof Object ? o : {}
    this.index = o.index || -1
    this.root = o.root
    this.children = o.children
    this.level = o.level
  }

  static fromAPI (o, groups) {
    let v = ViolationRule.fromAPI(o, groups)
    return new RuleNode(v)
  }
}

const state = {
  areaList: [],
  ruleList: [],
  groupList: []
}
const getters = {
  getField,
  getNewEvent: () => () => {
    return new ViolationEvent()
  }
}
const mutations = {
  updateField,
  setRuleList (state, data) {
    state.ruleList = data
  },
  setGroups (state, data) {
    state.groupList = data
  },
  setArea (state, data) {
    state.areaList = data
  }
}

const actions = {
  async getArea ({dispatch, commit, state}) {
    if (state.areaList.length) {
      return state.areaList
    }
    let data = await dispatch('getDataFromApi', {
      method: 'get',
      url: '/violationApi/violation/area'
    }, {root: true})
    if (data instanceof Array) {
      commit('setArea', data)
      return {items: data, amount: data.length}
    }
    else {
      commit('setArea', [])
      return {items: [], amount: 0}
    }
  },
  async getEvents ({dispatch}, {pagination, sortStack, search, filter, status = '', locale = 'runtime', self = false}) {
    let f = Object.assign({status: {key: 'status', value: status}}, filter)
    let {items, amount} = await dispatch('getDataList', {
      pagination,
      sortStack,
      search,
      filter: f,
      transDict: {
        phone: 'mobilePhone',
        plate: 'violatorObjectId',
        typeName: 'violationTypeName'
      },
      url: `/violationApi/violation/${locale}${self ? '/self' : ''}`
    }, {root: true})
    return {items: items.map(t => ViolationEvent.fromAPI(t)), amount: amount}
  },
  getAppointmentOrgSummary ({dispatch}, request) {
    return dispatch('getDataFromApi', {
      method: 'post',
      url: '/violationApi/violation/reports/appointment-org/summary',
      data: request
    }, {root: true})
  },
  getAppointmentOrgDetails ({dispatch}, {request, pagination}) {
    return dispatch('getDataFromApi', {
      method: 'post',
      url: '/violationApi/violation/reports/appointment-org/details',
      data: {...request, page: pagination.page - 1, size: pagination.rowsPerPage}
    }, {root: true})
  },
  async getRules ({dispatch, commit, state}, {filter, search, useCache = false}) {
    await dispatch('getGroups', true)

    function buildTree (items) {
      let tree = []
      let seq = '_'

      function findNode (route) {
        let node = tree
        route.forEach(i => {
          if (node instanceof Array) {
            node = node.find(n => Number(n.index) === Number(i))
            if (node) {
              if (!node.children) {
                node.children = []
              }
              node = node.children
            }
          }
        })
        return node
      }

      items.forEach((item, i, a) => {
        item.level = (item.code || '').split(seq).length
        a[i] = RuleNode.fromAPI(item, state.groupList)
      })

      let group = F.groupBy(items, 'level')
      // console.log('level', group)
      let TOP_LEVEL = '1'
      if (!group[TOP_LEVEL]) return []
      group[TOP_LEVEL].forEach((item, i) => {
        item.index = item.code
        item.root = null
      })
      tree.push(...group[TOP_LEVEL])
      delete group[TOP_LEVEL]

      // console.log('build root', tree)

      let keys = Object.keys(group)
      keys.sort((a, b) => Number(a) - Number(b))

      keys.forEach(i => {
        let items = group[i]
        // console.log('level', i, items)
        items.forEach(item => {
          let route = item.code.split(seq)
          let parent = findNode(route.slice(0, -1))
          // console.log('parent', parent)
          item.index = route[route.length - 1]

          let root = tree.find(t => t.index === route[0])

          item.root = root || item
          if (parent instanceof Array) {
            let insertIndex = parent.reduce((t, c, j) => c.index <= t ? j : t, 0) + 1
            parent.splice(insertIndex, 0, item)
          }
        })
      })
      console.log('success', tree)
      return tree
    }

    if (useCache && !filter && !search && state.ruleList.length) {
      return state.ruleList
    }
    // Fixme 请求中不能保证缓存
    try {
      let {items, amount} = await dispatch('getDataList', {
        url: '/violationApi/violation/rules',
        pagination: {page: 1, rowsPerPage: 1000},
        filter,
        search
      }, {root: true})

      // 获取全部数据，建树
      if (!filter && !search) {
        // console.log('get rules', items)
        let tree = buildTree(items)
        commit('setRuleList', tree)
        return tree
      }
      // 获取筛选数据， 返回数组
      else {
        return {items: items.map(t => ViolationRule.fromAPI(t, state.groupList)), amount}
      }
    }
    catch (e) {
      commit('setRuleList', [])
      throw e
    }
  },
  async deleteRules ({dispatch}, rules) {
    return dispatch('getDataFromApi', {
      method: 'delete',
      url: '/violationApi/violation/rule',
      data: {
        'violationDefinitions': rules.map(r => ({id: r.id}))
      }
    }, {root: true})
  },
  async getGroups ({dispatch, commit, state}, useCache = true) {
    if (state.groupList.length && useCache) {
      return state.groupList
    }
    let {items} = await dispatch('userAdmin/getGroups', {
      pagination: {page: 1, rowsPerPage: 1000},
      type: Group.VIOLATION
    }, {root: true})
    items.push(new Group({id: ORDER_TOKEN, name: '访客'}))
    commit('setGroups', items)
    return items
  },
  async setRule ({dispatch, state}, rule) {
    let res = await dispatch('getDataFromApi', {
      method: 'put',
      url: '/violationApi/violation/rule',
      data: {
        violationDefinitions: [
          {
            'id': rule.id,
            'name': rule.name,
            'description': rule.description,
            'severityDegree': Number(rule.severity || 0)
          }
        ]
      },
      params: {pid: rule.isRoot ? '' : rule.parent.id}
    }, {root: true})
    let newRule = res instanceof Array ? res[0] : res
    if (rule.isRoot) {
      // 检测规则
      let map = {}
      rule.templates.sms.forEach(group => {
        map[group.id] = group.templates.map((t, i) => {
          if (i >= +rule.max) return null
          let vars = {}
          t.variantList.forEach(variant => {
            vars[variant.key] = variant.value
          })
          return {
            times: +i + 1,
            imtpl: t.id,
            imtplName: t.name,
            token_list: vars
          }
        }).filter(t => !!t)
      })
      console.log(newRule)
      await dispatch('getDataFromApi', {
        method: 'put',
        url: '/violationApi/detection/',
        data: {
          'violationDetectionRules': [{
            'id': rule.detectionId || '',
            'viogrpFstlvlId': newRule.id,
            'maxToBan': rule.max,
            // Fixme 暂时不区分类型，固定sms
            'msgTmpltSet': JSON.stringify(map)
          }]
        }
      }, {root: true})
    }
    return ViolationRule.fromAPI(res, state.groupList)
  },
  async getParentRules ({dispatch}, parent) {
    parent = parent + ''
    if (parent === 'root') {
      return []
    }
    else {
      let route = parent.split('_')
      let codes = []
      route.reduce((t, a) => {
        let code = t ? t + '_' + a : a
        codes.push(code)
        return t ? t + '_' + a : a
      }, '')
      // console.log(codes, route)
      let {items} = await dispatch('getDataList', {
        url: '/violationApi/violation/rules',
        pagination: {page: 1, rowsPerPage: 1000},
        filter: {
          code: {key: 'code', value: codes, precious: true}
        }
      }, {root: true})
      return items.map(t => ViolationRule.fromAPI(t))
    }
  },
  async submitEvent ({dispatch}, event) {
    const roleStr = {
      [VIOLATION_ROLE.TRAFFIC_ADMIN]: 'trafficController',
      [VIOLATION_ROLE.ALARM_ADMIN]: 'alarmCenter',
      [VIOLATION_ROLE.VIOLATION_ADMIN]: 'admin'
    }
    let result = event.results[event.submitBy] || {}
    return dispatch('getDataFromApi', {
      method: 'post',
      url: '/violationApi/violation/',
      data: {
        'objectCode': event.plate,
        'area': result.area,
        'ruleId': result.typeId,
        'comment': result.comment,
        'fileList': result.imageList.map(img => ({
          type: 'pic',
          path: img.url
        })).filter(f => !!f.path)
      },
      params: {pipe: roleStr[event.submitBy]}
    }, {root: true})
  },
  async preliminaryConfirm ({dispatch}, event) {
    let res = await dispatch('getDataFromApi', {
      method: 'post',
      url: '/violationApi/violation/confirm',
      data: {
        'violationId': event.id,
        'ruleId': event.typeId,
        'comment': event.results[VIOLATION_ROLE.ALARM_ADMIN].comment,
        'fileList': event.results[VIOLATION_ROLE.ALARM_ADMIN].imageList.map(img => ({
          type: 'pic',
          path: img.url
        })).filter(f => !!f.path)
      }
    }, {root: true})
    return ViolationEvent.fromAPI(res)
  },
  async finalConfirm ({dispatch}, event) {
    // 修改信息，确认违章，发送短信

    // 修改信息
    await dispatch('getDataFromApi', {
      method: 'post',
      url: '/violationApi/violation/confirm/admin',
      data: {
        'violationId': event.id,
        'ruleId': event.typeId,
        'comment': event.results[VIOLATION_ROLE.VIOLATION_ADMIN].comment,
        'fileList': event.results[VIOLATION_ROLE.VIOLATION_ADMIN].imageList.map(img => ({
          type: 'pic',
          path: img.url
        })).filter(f => !!f.path)
      }
    }, {root: true})

    // 确认违章
    let msg = await dispatch('sendMessage', event)
    await dispatch('getDataFromApi', {
      method: 'post',
      url: `/violationApi/violation/${event.id}/confirm`,
      data: {}
    }, {root: true})

    // 发送短信
    return msg
  },

  async revokeEvent ({dispatch}, event) {
    return dispatch('getDataFromApi', {
      method: 'delete',
      url: `/violationApi/violation/${event.id}/revoke`
    }, {root: true})
  },
  async predictMessage ({dispatch}, event) {
    let res = await dispatch('getDataFromApi', {
      method: 'post',
      url: '/violationApi/violation/predictMsg',
      data: {
        'violationId': event.id,
        'sendMsg': false
      }
    }, {root: true})
    return res
  },
  async sendMessage ({dispatch}, event) {
    let res = await dispatch('getDataFromApi', {
      method: 'post',
      url: '/violationApi/violation/predictMsg',
      data: {
        'violationId': event.id,
        'sendMsg': true
      }
    }, {root: true})
    return res
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
